import { createContext } from 'react';
import { Views } from '~/utilities';

export interface ViewContextType {
  view: Views;
  isMobile: boolean;
  handleViewChange: (view: Views) => void;
}

export const ViewContext = createContext<ViewContextType | undefined>(
  undefined
);
